import { colors } from "./colors";

type ColorMap = typeof colors;

/**
 * This is a flattened, string map of the `colors` object.
 *
 * For example, `colors.blue.primary` is encoded as the string `"blue.primary"`.
 */
export type FlatColorMap = {
  [BaseKey in keyof ColorMap]: ColorMap[BaseKey] extends string ? BaseKey : `${BaseKey}.${keyof ColorMap[BaseKey] & string}`;
}[keyof ColorMap];

export const extractFlatColor = (color: FlatColorMap): string => {
  const [base, shade] = color.split(".");

  const scale = colors[base as keyof ColorMap] as any;

  switch (typeof scale) {
    case "string":
      return scale;
    case "undefined":
      return colors.grey.darkest;
    default:
      return scale[shade as keyof typeof scale] ?? colors.grey.darkest;
  }
};
